import React from 'react';

import { InlineFilterSectionProps, InlineFiltersSection } from 'components/inline-filters/InlineFilters.Section';

type Props = InlineFilterSectionProps & {
    icon: React.ReactNode;
};

// TODO: refactor remove
const InlineFiltersSectionWithIcon = (props: Props) => {
    return <InlineFiltersSection {...props} />;
};

export { InlineFiltersSectionWithIcon };
